import { catchError } from 'rxjs/operators';
import { CustomtranslateLoaderService } from './services/customtranslateLoader/customtranslate-loader.service';
import { environment } from './../environments/environment';
import { IonicStorageModule } from '@ionic/storage-angular';
import { MatStepperModule } from '@angular/material/stepper';
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgApexchartsModule } from 'ng-apexcharts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InappKeyboardComponent } from './components/inapp-keyboard/inapp-keyboard.component';
import { SafePipe } from './pipes/safe.pipe';
import { KeyboardService } from './services/keyboard/keyboard.service';

// Sentry.init(
//   {
//     dsn: environment.sentryURL,
//     tracesSampleRate: 0.1,
//     // Set your release version, such as "getsentry@1.0.0"
//     release: "wenea-capacitor@" + environment.version,
//   },
//   // Forward the init method from @sentry/angular
//   SentryAngular.init
// );


// export function HttpLoaderFactory(http: HttpClient) {
//   const remoteUrl = 'https://backend-pro.wenea.site/app/json/i18n/new_trans_android/';
//   const localUrl = '/assets/i18n/';
//   const fallbackLanguage = 'en';

//   const loader = new TranslateHttpLoader(http, '', '.json');

//   return {
//     getTranslation: (lang: string) => {
//       const remoteFileUrl = `${remoteUrl}${lang}.json`;
//       const localFileUrl = `${localUrl}${lang}.json`;
//       const fallbackFileUrl = `${localUrl}${fallbackLanguage}.json`;

//       return http.get(remoteFileUrl, { responseType: 'text' }).pipe(
//         catchError(() => http.get(localFileUrl, { responseType: 'text' }).pipe(
//           catchError(() => http.get(fallbackFileUrl, { responseType: 'text' }))
//         ))
//       );
//     }
//   };
// }

export function HttpLoaderFactory(http: HttpClient) {
  const remoteUrl = 'https://backend-pro.wenea.site/app/json/i18n/kiosk_trans/';
  const localUrl = '/assets/i18n/';

  const loaderUrl = localUrl;

  return new TranslateHttpLoader(http, loaderUrl, '.json');
}

function hasNetworkConnection(): boolean {
  return navigator.onLine;
}
@NgModule({
  declarations: [AppComponent, SafePipe, InappKeyboardComponent],
  imports: [
    BrowserModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true,
      backButtonText: '' // Set an empty string to have no text next to the back icon
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgApexchartsModule,
    MatStepperModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatProgressBarModule
  ],
  providers: [
    KeyboardService,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    {
      provide: ErrorHandler,
      // Attach the Sentry ErrorHandler
      //useValue: SentryAngular.createErrorHandler(),
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
